import React, { useEffect, useRef, useState } from "react";
import { Card, CardBody, Row, Col, Input, Button, Label } from "reactstrap";
import { useNavigate, useLocation } from "react-router-dom";
import swal from "sweetalert";
import {
  AllCategoryList,
  CreateSubCategory,
  Update_SubCategory,
} from "../../ApiEndPoint/ApiCalling";
import axiosConfig from "../../AxiosConfig"
export default function AddSubCategory() {
  const navigate = useNavigate();
  const location = useLocation();

  const editData = location.state?.data;
  const isEdit = !!editData;
  const [catList, setCatList] = useState([]);
  const [units, setUnits] = useState([]);
  const [selectedUnits, setSelectedUnits] = useState([]);
  const [unitDropdownOpen, setUnitDropdownOpen] = useState(false);
  const unitDropdownRef = useRef(null);
  const [form, setForm] = useState({
    category: "",
    subcategory_name: "",
    description: "",
    status: "Active",
  });

  // 🔄 handle change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  // 📦 Fetch Category List
  useEffect(() => {
    const fetchData = async () => {
      try {
        const userData = JSON.parse(localStorage.getItem("userData"));

        // Category
        const categoryRes = await AllCategoryList(
          userData?._id,
          userData?.database
        );
        if (categoryRes?.Category) {
          setCatList(categoryRes.Category);
        }

        // Units
        const res = await axiosConfig.get(
          `/units/view-unit/${userData.database}`
        );
        const dynamicUnits = res?.data?.dynamicUnit || [];

        // Sabhi Units ko combine karo
        const allUnits = dynamicUnits.flatMap(
          (item) => item?.Units || []
        );

        // Duplicate unitId remove karo
        const uniqueUnits = Array.from(
          new Map(
            allUnits.map((unit) => [unit.unitId, unit])
          ).values()
        );

        setUnits(uniqueUnits);

      } catch (err) {
        console.log(err);
      }
    };

    fetchData();
  }, []);
useEffect(() => {
  if (!editData || !catList.length) return;

  const selectedCategory = catList.find(
    (cat) =>
      String(cat.name).trim().toLowerCase() ===
      String(editData.categoryName).trim().toLowerCase()
  );

  console.log("Edit Data:", editData);
  console.log("Category List:", catList);
  console.log("Selected Category:", selectedCategory);

  setForm({
    category: selectedCategory?._id || "",

    subcategory_name:
      editData.name || "",

    description:
      editData.description || "",

    status:
      editData.status || "Active",
  });

  setSelectedUnits(
    Array.isArray(editData.units)
      ? editData.units
      : []
  );
}, [editData, catList]);
  const handleUnitChange = (unit) => {
    setSelectedUnits((prev) => {
      const alreadySelected = prev.some(
        (item) => item.unitId === unit.unitId
      );

      if (alreadySelected) {
        return prev.filter(
          (item) => item.unitId !== unit.unitId
        );
      }

      return [
        ...prev,
        {
          unitId: unit.unitId,
          unitName: unit.unitName,
        },
      ];
    });
  };
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        unitDropdownRef.current &&
        !unitDropdownRef.current.contains(event.target)
      ) {
        setUnitDropdownOpen(false);
      }
    };

    document.addEventListener(
      "mousedown",
      handleOutsideClick
    );

    return () => {
      document.removeEventListener(
        "mousedown",
        handleOutsideClick
      );
    };
  }, []);
  // 🚀 Submit
  // const submitHandler = async (e) => {
  //   e.preventDefault();

  //   try {
  //     const userData = JSON.parse(localStorage.getItem("userData"));

  //     const data = new FormData();
  //     data.append("created_by", userData?._id);
  //     data.append("name", form.subcategory_name);
  //     data.append("category", form.category);
  //     data.append("description", form.description);
  //     data.append("status", form.status);
  //     data.append("units", JSON.stringify(selectedUnits));
  //     await CreateSubCategory(data);

  //     swal("Success", "SubCategory Added Successfully", "success");

  //     navigate("/production?view=category-subcategory-units");
  //   } catch (err) {
  //     console.error(err);
  //     swal("Error", "Something went wrong", "error");
  //   }
  // };
const submitHandler = async (e) => {
  e.preventDefault();

  try {
    const userData = JSON.parse(
      localStorage.getItem("userData")
    );

    const data = new FormData();

    data.append("created_by", userData?._id);
    data.append("name", form.subcategory_name);
    data.append("category", form.category);
    data.append("description", form.description);
    data.append("status", form.status);
    data.append("units", JSON.stringify(selectedUnits));

    if (isEdit) {
      // Category ID
      const categoryId = form.category;

      // SubCategory ID
      const subCategoryId = editData._id;

      console.log("Category ID:", categoryId);
      console.log("SubCategory ID:", subCategoryId);

      await Update_SubCategory(
        categoryId,
        subCategoryId,
        data
      );

      swal(
        "Success!",
        "Your Subcategory has been Updated",
        "success"
      );
    } else {
      await CreateSubCategory(data);

      swal(
        "Success",
        "SubCategory Added Successfully",
        "success"
      );
    }

    navigate(
      "/production?view=category-subcategory-units"
    );

  } catch (err) {
    console.error(err);

    swal(
      "Error",
      err?.response?.data?.message ||
        "Something went wrong",
      "error"
    );
  }
};
  return (
    <div className="erp-page-grid">
      <Card className="erp-card">
        <CardBody>
          <h2 style={{ marginBottom: "20px" }}>
            {isEdit ? "Edit SubCategory" : "Add SubCategory"}
          </h2>

          <form onSubmit={submitHandler}>
            <Row>
              {/* Select Category */}
              <Col md="6">
                <Label>Select Category</Label>
                <Input
                  type="select"
                  name="category"
                  value={form.category}
                  onChange={handleChange}
                  required
                >
                  <option value="">--Select Category--</option>
                  {catList.map((cat) => (
                    <option key={cat._id} value={cat._id}>
                      {cat.name}
                    </option>
                  ))}
                </Input>
              </Col>
              <Col md="6">
                <Label>Units</Label>

                <div
                  ref={unitDropdownRef}
                  className="position-relative"
                >
                  {/* Dropdown Button */}
                  <div
                    className="form-control"
                    style={{
                      cursor: "pointer",
                      minHeight: "38px"
                    }}
                    onClick={() =>
                      setUnitDropdownOpen((prev) => !prev)
                    }
                  >
                    {selectedUnits.length > 0
                      ? selectedUnits
                        .map((unit) => unit.unitName)
                        .join(", ")
                      : "Select Units"}


                  </div>

                  {/* Dropdown */}
                  {unitDropdownOpen && (
                    <div
                      className="border rounded bg-white p-2"
                      style={{
                        position: "absolute",
                        width: "100%",
                        zIndex: 999,
                        maxHeight: "250px",
                        overflowY: "auto"
                      }}
                    >
                      {units.map((unit) => {
                        const isSelected = selectedUnits.some(
                          (item) =>
                            item.unitId === unit.unitId
                        );

                        return (
                          <div
                            key={unit._id}
                            className="d-flex align-items-center p-2"
                          >
                            <Input
                              type="checkbox"
                              className="mr-2"
                              checked={isSelected}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setSelectedUnits((prev) => [
                                    ...prev,
                                    {
                                      unitId: unit.unitId,
                                      unitName: unit.unitName
                                    }
                                  ]);
                                } else {
                                  setSelectedUnits((prev) =>
                                    prev.filter(
                                      (item) =>
                                        item.unitId !== unit.unitId
                                    )
                                  );
                                }
                              }}
                            />

                            <span>{unit.unitName}</span>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </Col>
              {/* SubCategory Name */}
              <Col md="6">
                <Label>SubCategory Name</Label>
                <Input
                  name="subcategory_name"
                  value={form.subcategory_name}
                  onChange={handleChange}
                  required
                />
              </Col>

              {/* Description */}
              <Col md="6">
                <Label>Description</Label>
                <Input
                  type="textarea"
                  name="description"
                  value={form.description}
                  onChange={handleChange}
                />
              </Col>

              {/* Status */}
              <Col md="2">
                <Label>Status</Label>
                <Input
                  type="select"
                  name="status"
                  value={form.status}
                  onChange={handleChange}
                >
                  <option>Active</option>
                  <option>Deactive</option>
                </Input>
              </Col>
            </Row>

            <Button
              color="primary"
              type="submit"
              style={{ marginTop: "20px" }}
            >
              {isEdit ? "Update SubCategory" : "Add SubCategory"}
            </Button>

            <Button
              color="secondary"
              style={{ marginTop: "20px", marginLeft: "10px" }}
              onClick={() => navigate(-1)}
            >
              Cancel
            </Button>
          </form>
        </CardBody>
      </Card>
    </div>
  );
}